import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export const helpConsensus: ISidebarHelp = {
	title: 'Consensos',
	firstParagraph: `Etapa destinada a aplicação do consenso, sendo a fase de maior importância no processo de previsão de demanda, pois a partir da interação dos responsáveis pelo negócio, gera-se o senso comum refletido nas perspectivas [quantidade e receita] no tempo.`,
	secondParagraph: `Para o ciclo atual, em conjunto com todos os especialistas envolvidos, deve ser definido a demanda em quantidade para todas as famílias de produto em seus respectivos canais de vendas.`,
	thirdParagraph: `Acesse o botão para realizar seu consenso.`,
	firstLink: URL_CT360,
	secondLink: URL_FALE_CONOSCO,
};
